import { IMentionAttachmentCommentData } from '../comment';
import { IEmployee, IEmployeeData } from '../employee';
import { IOvertimeRequestCommentFieldErrorData } from '../overtime-request';
import { IUserData } from '../user';

// API Data

export type IVacationCarryOverRequestCommentData = IMentionAttachmentCommentData;
export interface IVacationCarryOverRequestData {
  id?: number;
  state?: VacationCarryOverRequestStateEnum;
  employee?: IEmployeeData | number;
  amount_requested: number;
  year: number;
  reason: string;
  approvers: IVacationCarryOverApprovalData[];
  created_at?: string | Date;
  updated_at?: string | Date;
}

export interface IVacationCarryOverApprovalData {
  id?: number;
  approver: number | IUserData;
  status: VacationCarryOverApprovalState;
  created_at?: string;
  updated_at?: string;
}

export interface IVacationCarryOverRequestStateInfoData {
  display_name: string;
  color: string;
}

export type IVacationCarryOverRequestCommentFieldErrorData = IOvertimeRequestCommentFieldErrorData;
export interface IVacationCarryOverRequestFieldErrorData {
  state?: string[];
  amount_requested?: string[];
  year?: string[];
  employee?: string[];
  owner?: string[];
  reason?: string[];
  approvers?: IVacationCarryOverApprovalFieldErrorData[];
}

export interface IVacationCarryOverApprovalFieldErrorData {
  approver: string[];
  status: string[];
}

export interface IVacationCarryOverRequest
  extends IVacationCarryOverRequestData {
  employee?: IEmployee | number;
  approvers: IVacationCarryOverApproval[];
  validate(): boolean;
  getStateInfo(): IVacationCarryOverRequestStateInfoData;
}

export interface IVacationCarryOverApproval
  extends IVacationCarryOverApprovalData {
  validate(): boolean;
}

export interface IVacationCarryOverRequestComment
  extends IVacationCarryOverRequestCommentData {
  validate(): boolean;
}

export interface IVacationCarryOverRequestFieldError
  extends IVacationCarryOverRequestFieldErrorData {
  clearErrors(): void;
}

export interface IVacationCarryOverRequestCommentFieldError
  extends IVacationCarryOverRequestCommentFieldErrorData {
  clearErrors(): void;
}
export interface IVacationCarryOverApprovalFieldError
  extends IVacationCarryOverApprovalFieldErrorData {
  clearErrors(): void;
}

export enum VacationCarryOverApprovalState {
  Tentative,
  Approved,
  Rejected
}

export enum VacationCarryOverRequestStateEnum {
  Draft,
  Submitted,
  Approved,
  Rejected,
  Cancelled
}
